import { createReducer, on } from "@ngrx/store";
import {
  createTeamTeachersSuccess,
  createTeamTeachersFail,
  createTeamTeachersLoad,
} from "../../actions/admin/create-team-teachers.actions";
import { CreateTeamTeachersResponse } from "src/app/shared/interfaces/orgadmin/course-teachers";
import { RequestStatus } from "src/app/shared/interfaces/request-status";

export interface CreateTeamTeachersState {
  status: RequestStatus;
  error: CreateTeamTeachersResponse | null;
}

const initialState: CreateTeamTeachersState = {
  status: "IDLE",
  error: null,
};

export const createTeamTeachersReducer = createReducer(
  initialState,
  on(
    createTeamTeachersLoad,
    (state): CreateTeamTeachersState => ({
      ...state,
      status: "PENDING",
      error: null,
    }),
  ),
  on(
    createTeamTeachersSuccess,
    (state): CreateTeamTeachersState => ({
      ...state,
      status: "SUCCESS",
      error: null,
    }),
  ),
  on(
    createTeamTeachersFail,
    (state, { error }): CreateTeamTeachersState => ({
      ...state,
      status: "FAILED",
      error,
    }),
  ),
);
